import React, { useState, useEffect } from "react";
import { Puzzle, Brain, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

function Teaser({ icon: Icon, label, item, k, reveal, setReveal }) {
  if (!item) return null;
  return (
    <div className="rounded-xl border border-rud bg-elevated p-4">
      <div className="flex items-center gap-2 text-sm font-medium"><Icon size={15} className="text-brand" /> {label}</div>
      <p className="text-sm mt-1">{item.q}</p>
      <button data-testid={`reveal-${k}`} onClick={() => setReveal({ ...reveal, [k]: !reveal[k] })} className="text-xs text-brand mt-2">{reveal[k] ? "Hide" : "Reveal"} answer</button>
      {reveal[k] && <p className="text-sm text-brand mt-1">{item.a}</p>}
    </div>
  );
}

export default function StudyGames({ category = "General Knowledge" }) {
  const [g, setG] = useState(null);
  const [reveal, setReveal] = useState({});
  const [picked, setPicked] = useState({});
  useEffect(() => { setG(null); setPicked({}); setReveal({}); api.get(`/lms/games/daily?category=${encodeURIComponent(category)}`).then(({ data }) => setG(data)).catch(() => {}); }, [category]);
  if (!g) return null;
  return (
    <div className="rud-card rounded-2xl p-6" data-testid="study-games">
      <div className="flex items-center gap-2 text-brand text-xs uppercase tracking-widest mb-3"><Sparkles size={14} /> Daily brain teasers · {g.category}</div>
      {(g.quiz || []).map((q, i) => (
        <div key={i} className="mb-4">
          <div className="text-sm font-medium">{i + 1}. {q.q}</div>
          <div className="grid sm:grid-cols-2 gap-2 mt-2">
            {q.options.map((o, j) => {
              const show = picked[i] != null; const chosen = picked[i] === j; const correct = j === q.answer_index;
              return (
                <button key={j} data-testid={`quiz-${i}-opt-${j}`} disabled={show} onClick={() => setPicked({ ...picked, [i]: j })}
                  className={`text-left text-sm rounded-lg border px-3 py-2 transition-colors ${show ? (correct ? "border-green-500 bg-green-500/10" : chosen ? "border-red-500 bg-red-500/10" : "border-rud") : "border-rud hover:border-brand/60"}`}>{o}</button>
              );
            })}
          </div>
          {picked[i] != null && q.explanation && <div className="text-xs text-sec mt-1">{q.explanation}</div>}
        </div>
      ))}
      <div className="grid sm:grid-cols-2 gap-3 mt-2">
        <Teaser icon={Brain} label="Riddle" item={g.riddle} k="r" reveal={reveal} setReveal={setReveal} />
        <Teaser icon={Puzzle} label="Puzzle" item={g.puzzle} k="p" reveal={reveal} setReveal={setReveal} />
      </div>
    </div>
  );
}
